import Request from '@/js_sdk/luch-request/index.js'
import { BASE_API } from './url.js'

import { userStorage } from '@/hooks/useStorage';
import { expireSession } from '@/common/auth/session';
const { getStorage } = userStorage();

if (process.env.NODE_ENV == 'development') {
	console.log(`%c api_path ${BASE_API}`,
		'background:#5ac725;padding:0 5px 1px 0;border-radius: 3px 0 0 3px;  color: #ffffff')
}
const apiPath = BASE_API
// 获取token
const getTokenStorage = () => {
	const token = getStorage('token')
	if (token) {
		return token
	} else {
		return ''
	}
}

// 请求
const http = new Request()
http.setConfig((config : any) => {
	config.baseURL = `${BASE_API}`;
	config.withCredentials = false;
	config.custom.auth = true;
	config.custom.catch = true;
	config.custom.toast = true;
	config.custom.loading = false;
	return config
})

http.interceptors.request.use((config) => {
	config.data = config.data || {}
	if (config.custom.loading) uni.showLoading()
	if (config.custom.auth) {
		config.header['blade-auth'] = getTokenStorage() && `${getTokenStorage()}` || "";
	} else {
		config.header['Content-Type'] = 'application/x-www-form-urlencoded'
		if (config.method === 'GET' || config.method === 'DELETE') {
			config.params = {
				...config.params,
				token: getTokenStorage()
			}
		} else if (config.method === 'POST' || config.method === 'PUT') {
			config.data = {
				...config.data,
				token: getTokenStorage()
			}
		}
	}

	// 如果token不存在，return Promise.reject(config) 会取消本次请求
	//  if (!token) { 
	//    return Promise.reject(config)
	//  }
	return config
}, (config : any) => {
	return Promise.reject(config)
})

http.interceptors.response.use(async (response) => {
	/* 请求之后拦截器。可以使用async await 做异步操作  */
	if (response.config.custom.loading) uni.hideLoading()

	if (response.statusCode !== 200) {
		return Promise.reject(response)
	} else {
		const data = response.data
		if (data.code == 0) {
			response.config.custom?.toast && uni.showToast({
				title: data.msg || data.message,
				icon: 'none',
				duration: 2000
			})
			if (response.config.custom?.catch) {
				return Promise.reject(data)
			} else {
				return Promise.resolve(data)
			}
		} else if (data.code == -1) {
			expireSession(response.config.header?.['blade-auth']);
			return Promise.reject(response.data)
			// return false
		} else {
			return Promise.resolve(data)
		}
	}
	return response
}, (response : any) => {
	return Promise.reject(response)
})
// 上传 
function http_upload({
	loading = true,
	header_token = true,
	url = '/app/tool/uploadImage',
	file, // 假设file是一个File对象，但它是可选的  
	filePath, // filePath是文件的本地路径，也是可选的，但通常你需要它 
	name = 'image[]',
	formData = {}
} : { [key : string] : any }) {
	loading && uni.showLoading()
	return new Promise((resolve, reject) => {
		// 上传与普通请求使用同一登录凭证；后端只读取 blade-auth。
		const token = getTokenStorage()
		const header = { 'blade-auth': token }
		const uploadFormData = { ...formData }
		if (!header_token) {
			uploadFormData.token = token
		}
		uni.uploadFile({
			url: `${BASE_API}${url}`,
			fileType: 'image',
			file,
			filePath,
			name,
			formData: uploadFormData,
			header,
			success: res => {
				loading && uni.hideLoading();
				try {
					const imgRes = JSON.parse(res.data)
					if (res.statusCode === 200 && imgRes.code == 1) {
						resolve(imgRes)
						return
					}
					uni.showToast({ title: imgRes.msg || imgRes.message || '上传失败', icon: 'none' })
					if (imgRes.code == -1) {
						expireSession(token);
					}
					reject(imgRes)
				} catch (err) {
					uni.showToast({ title: '上传响应异常，请重试', icon: 'none' })
					reject(err)
				}
			},
			fail: err => {
				loading && uni.hideLoading();
				uni.showToast({ title: '上传失败，请重试', icon: 'none' })
				reject(err);
			}
		});
	})
}
export {
	apiPath,
	http,
	http_upload
}
